import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

const SurveyLinkWarningModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.surveyLinkWarningModalVisible}
        onClose={distributeStore.hideSurveyLinkWarningModal}
    >
        <Typography type="h2">{i18n.t('distributionSurveyLinkModal.title')}</Typography>

        <br />

        <Typography style={{ textAlign: 'center' }}>{i18n.t('distributionSurveyLinkModal.subtitle')}</Typography>

        <br />

        <hr />

        <br />

        <div className="delete-modal-footer-content">
            <Button
                cssClass="regular tertiary"
                onClick={distributeStore.hideSurveyLinkWarningModal}
                label={i18n.t('close')}
            />
        </div>
    </Modal>
)

export default observer(SurveyLinkWarningModal)
